import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
//graphql
import { useLazyQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
//Material-UI
import { makeStyles } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MuiAlert from '@material-ui/lab/Alert';
//DS
import { GeneralInformacion, TicketDetalle, Mensaje } from './componentes';
import { validacion } from 'lib.common';
import { openMsg, loadingModal } from 'redux-app';
const { esVarNullUndef } = validacion;

function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles(theme => ({
   root: {
      padding: theme.spacing(4)
   }
}));
const queryRecuperar = gql`
   query ticketDetalles($codigoTicket: String!) {
      ticket(codigo: $codigoTicket) {
         codigo
         asunto
         prioridad
         tipoTicket {
            codigo
            descripcion
         }
         cliente {
            codigo
            nombre
            apPaterno
            apMaterno
            razonSocial
            email
         }
         fecha
         estado
      }
      ticketDetallesFiltro(ticket: $codigoTicket) {
         codigo
         ticket {
            codigo
            asunto
         }
         descripcion
         cliente {
            codigo
            nombre
            apPaterno
            apMaterno
            razonSocial
            email
         }
         asesor {
            codigo
            nombre
            apPaterno
            apMaterno
            especialidad
         }
         fecha
         valorizacion
      }
   }
`;

function VerTicket({ estado: estadoProp, openMsgModal, openWaitModal }) {
   const classes = useStyles();
   //estados
   const [responder, setResponder] = useState(false);
   const [procesarOK, setProcesarOK] = useState(false);
   const [estado, setEstado] = useState(estadoProp);
   const { ticketCod } = useParams();
   // const ticketCod = "TIC001";
   const [recuperar, { called, loading, data, error, refetch }] = useLazyQuery(queryRecuperar, {
      variables: { codigoTicket: ticketCod } //Alex
   });

   useEffect(() => {
      let eMsg = '';

      if (!esVarNullUndef(error)) {
         eMsg = eMsg + JSON.stringify(error);
      }
      if (eMsg !== '') {
         openMsgModal(eMsg);
      }
   }, [error]);

   useEffect(() => {
      if (procesarOK) {
         recuperar();
         setProcesarOK(false);
      }
   }, [procesarOK]);

   useEffect(() => {
      //by Alex
      if (data !== undefined && data !== null) {
         setEstado(data['ticket'].estado);
      }
   }, [data]);

   useEffect(() => {
      openWaitModal(loading);
   }, [loading]);

   if (!called) {
      return <> {recuperar()}</>;
   }

   return (
      <div className={classes.root}>
         <Grid container spacing={3}>
            <Grid item xs={3}>
               {data !== undefined && (
                  <GeneralInformacion data={data['ticket']} setProcesarOK={setProcesarOK} />
               )}
            </Grid>
            <Grid item xs={9}>
               <Typography variant="h2" gutterBottom>
                  Ver Ticket
               </Typography>
               {responder && (
                  <Mensaje
                     data={data['ticket']}
                     setResponder={setResponder}
                     setProcesarOK={setProcesarOK}
                  ></Mensaje>
               )}
               <br></br>
               {estado === 3 && <Alert severity="warning">Ticket cerrado</Alert>}
               <br></br>
               {data !== undefined && (
                  <TicketDetalle
                     data={data['ticketDetallesFiltro']}
                     setResponder={setResponder}
                     responder={responder}
                     estado={estado} />
               )}
            </Grid>
         </Grid>
      </div>
   );
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openMsgModal: msg => dispatch(openMsg(msg)),
      openWaitModal: loading => dispatch(loadingModal(loading))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(VerTicket);